'use strict';

import 'es6-promise-promise';

var lines = 1;
var numOfAllowedLines = 1;
let valueHistory = [];
let currentValueIndex = -1;

function saveValueToHistory(element) {
    valueHistory = valueHistory.slice(0, currentValueIndex + 1);
    valueHistory.push(element.value);
    currentValueIndex++;
}
function getKeyNum(e) {
    var keynum;
    if (window.event) {
        keynum = e.keyCode;
    } else if (e.which) {
        keynum = e.which;
    }
    return keynum;
}
var limitLines = function(e) {
    numOfAllowedLines = window.SFRA.SitePreferences.giftMessageAllowedLinesCount || this.rows;
    var keynum = getKeyNum(e);
    if (e.ctrlKey && (e.key === 'x' || e.key === 'X') && this.value.length === 125) {
        e.preventDefault();
        let startInd = this.selectionStart;
        let endInd = this.selectionEnd;
        this.value = this.value.substring(0, startInd) + this.value.substring(endInd);
        this.selectionStart = this.selectionEnd = startInd;
        valueHistory.push(this.value);
        currentValueIndex++;
    }
    // Check if the total number of characters exceeds 125 characters
    if (this.value.length >= 125 && keynum !== 8 && keynum !== 13 && keynum !== 37 && keynum !== 38 && keynum !== 39 && keynum !== 40 && keynum !== 46) { // Allow backspace, keyup, keydown, enter and delete keys
        e.stopPropagation();
        e.preventDefault();
    } else if (keynum === 13) { // Enter key
        if (lines >= numOfAllowedLines) {
            e.stopPropagation();
            e.preventDefault();
        } else {
            lines++;
        }
    }
}
var setNumberOfLines = function() {
    lines = getNumberOfLines(this.value);
}
function getPasteDataToElement(element, clipPasteData) {
    let start = element.selectionStart;
    let end = element.selectionEnd;
    let charCount = countBackSlashChars(element.value, 125, false);
    var size = 0,
        pastedData = '',
        cursorPos = 125;
    let newLnChrCount = countBackSlashChars(clipPasteData, 125, true);
    if (element.value.length == 0 && newLnChrCount == 0) {
        pastedData = clipPasteData.trim().substring(0, 125);
        cursorPos = pastedData.length;
    } else if (element.value.length == 0 && newLnChrCount > 0) {
        pastedData = clipPasteData.trim().substring(0, 125 + (newLnChrCount / 2));
        cursorPos = pastedData.length;
    } else if (element.value.length >= 1 && element.value.length <= 125) {
        if (start == 0 && end == element.value.length && start != end && charCount == 0 && newLnChrCount == 0) {
            pastedData = clipPasteData.trim().substring(0, 125);
            cursorPos = pastedData.length;
        } else if (start == 0 && end == element.value.length && start != end && charCount == 0 && newLnChrCount > 0) {
            pastedData = clipPasteData.length <= 125 ? clipPasteData : clipPasteData.trim().substring(0, 125 + (newLnChrCount / 2));
            cursorPos = pastedData.length;
        } else if (start == end && charCount == 0 && newLnChrCount == 0) {
            size = 125 - element.value.length;
            pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
            cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
        } else if (start == end && charCount == 0 && newLnChrCount > 0) {
            let reqCharsCount = 125 - element.value.length;
            let clipNewLineCnt = countBackSlashChars(clipPasteData.substring(0, reqCharsCount), reqCharsCount, true);
            size = clipNewLineCnt == 0 ? reqCharsCount : reqCharsCount + (charCount / 2);
            pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
            cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
        } else if (start == end && charCount > 0 && newLnChrCount == 0) {
            size = 125 - element.value.length;
            pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
            cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
        } else if (start == end && charCount > 0 && newLnChrCount > 0) {
            let reqCharCount = charCount < numOfAllowedLines && (charCount + 1) == numOfAllowedLines ? 125 - element.value.length : 125 - element.value.length + (numOfAllowedLines - (charCount + 1));
            let clipNewLineCnt = countBackSlashChars(clipPasteData.substring(0, reqCharCount), reqCharCount, true);
            if (clipNewLineCnt == 0) {
                pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, reqCharCount) + element.value.substring(end);
                cursorPos = start + (clipPasteData.trim().length >= reqCharCount ? reqCharCount : clipPasteData.trim().length);
            }
            if (pastedData == '' && (charCount + Math.ceil(clipNewLineCnt / 2)) < numOfAllowedLines) {
                pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, (reqCharCount + Math.ceil(clipNewLineCnt / 2))) + element.value.substring(end)
                cursorPos = start + (reqCharCount + Math.ceil(clipNewLineCnt / 2))
            } else if (pastedData == '' && (charCount + Math.ceil(clipNewLineCnt / 2)) >= numOfAllowedLines) {
                pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, clipPasteData.substring(0, reqCharCount).indexOf('\r\n')) + element.value.substring(end);
                cursorPos = start + clipPasteData.trim().indexOf('\r\n');
            }
        } else if (start != end && charCount == 0 && newLnChrCount == 0) {
            size = 125 - element.value.length + (end - start);
            pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
            cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
        } else if (start != end && charCount == 0 && newLnChrCount > 0) {
            let reqCharsCount = 125 - element.value.length + (end - start);
            let clipNewLineCnt = countBackSlashChars(clipPasteData.substring(0, reqCharsCount), reqCharsCount, true);
            size = clipNewLineCnt == 0 ? reqCharsCount : reqCharsCount + Math.ceil(charCount / 2);
            pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
            cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
        } else if (start != end && charCount > 0 && newLnChrCount == 0) {
            size = 125 - element.value.length + (end - start);
            pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
            cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
        } else if (start != end && charCount > 0 && newLnChrCount > 0) {
            let newLineCntSelectTxt = countBackSlashChars(element.value.substring(start, end));
            let existLineCount = charCount - newLineCntSelectTxt;
            let reqCharCount = existLineCount < numOfAllowedLines && (existLineCount + 1) == numOfAllowedLines ? 125 - element.value.length + (end - start) : 125 - element.value.length + (end - start) + (numOfAllowedLines - (existLineCount + 1));
            let clipNewLineCnt = countBackSlashChars(clipPasteData.substring(0, reqCharCount), reqCharCount, true);

            if (clipNewLineCnt == 0 ) {
                pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, reqCharCount) + element.value.substring(end);
                cursorPos = start + (clipPasteData.trim().length >= reqCharCount ? reqCharCount : clipPasteData.trim().length);
            } else if ((existLineCount + Math.ceil(clipNewLineCnt / 2)) < numOfAllowedLines) {
                size = reqCharCount + Math.ceil(clipNewLineCnt / 2);
                pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
                cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
            } else if ((existLineCount + Math.ceil(clipNewLineCnt / 2)) >= numOfAllowedLines) {
                size = reqCharCount - clipNewLineCnt;
                pastedData = element.value.substring(0, start) + clipPasteData.trim().substring(0, size) + element.value.substring(end);
                cursorPos = start + (clipPasteData.trim().length >= size ? size : clipPasteData.trim().length);
            }
        }
    }
    pasteDataToElement(element, pastedData, cursorPos);
}
function countBackSlashChars(value, allowChars, flag) {
    let charCount = 0;
    let i = 1;
    for (let ch of value) {
        if (flag && (ch === '\n' || ch === '\r') && i <= allowChars) {
            charCount++;
        } else if (!flag && ch === '\n' && i <= allowChars) {
            charCount++;
        }
        i++;
    }
    return charCount;
}
var limitPasteData = function(e) {
    var clipboardData,
        clipPasteData = '';
    // Stop data actually being pasted into div
    e.stopPropagation();
    e.preventDefault();
    clipboardData = e.clipboardData || window.clipboardData;
    if (typeof clipboardData !== undefined) {
        clipPasteData = clipboardData.getData('Text');
    } else {
        navigator.clipboard.readText()
            .then(text => {
                clipPasteData = text;
            })
            .catch(err => {
                console.error('Failed to read clipboard contents: ', err);
            });
    }
    if (clipPasteData) {
        getPasteDataToElement(this, clipPasteData);
    }
}
function pasteDataToElement(element, pastedData, pasteEndIndex) {
    if (pastedData.length > 125) {
        pastedData = pastedData.substring(0, 125 + (parseInt(countBackSlashChars(pastedData, 125, true)) / 2));
    }
    var pastedLines = getNumberOfLines(pastedData);
    if (pastedLines <= numOfAllowedLines) {
        lines = pastedLines;
        element.value = pastedData;
        // Move the cursor to the end of the pasted data
        element.selectionStart = element.selectionEnd = pasteEndIndex;
        valueHistory.push(element.value);
        currentValueIndex++;
    } else if (pastedLines > numOfAllowedLines) {
        element.value = pastedData
            .split(/\r\n|\r|\n/)
            .slice(0, numOfAllowedLines)
            .join('\n ');
        valueHistory.push(element.value);
        currentValueIndex++;
    }
}
function getNumberOfLines(str) {
    if (str) {
        return str.split(/\r\n|\r|\n/).length;
    }
    return 1;
}

export function ristrictNumberOfLinesInGiftMessage() {
    var limitedElements = document.getElementsByClassName('personalisation__card-textarea');
    if (limitedElements) {
        Array.from(limitedElements).forEach(function(element) {
            // Save the initial value to the history
            saveValueToHistory(element);

            element.addEventListener('keydown', limitLines);
            element.addEventListener('keyup', setNumberOfLines);
            element.addEventListener('cut', setNumberOfLines);
            element.addEventListener('paste', limitPasteData);

            // Add event listener for Ctrl+A to select all text
            element.addEventListener('keydown', function(e) {
                if (e.ctrlKey && (e.key === 'a' || e.key === 'A')) {
                    e.preventDefault();
                    element.select();
                }
            });
            element.addEventListener('keydown', function(e) {
                let startInd = element.selectionStart;
                let endInd = element.selectionEnd;
                if (element && element.value) {
                    if (startInd == 0 && element.value.length == endInd && e.ctrlKey && (e.key === 'v' || e.key === 'V')) {
                        e.preventDefault();
                        valueHistory.push(element.value);
                        currentValueIndex++;
                        navigator.clipboard.readText()
                            .then(text => {
                                pasteDataToElement(element, text, endInd);
                            })
                            .catch(err => {
                                console.error('Failed to read clipboard contents: ', err);
                            });
                    } else if (startInd != endInd && (endInd - startInd) != 125 && element.value.length <= 125 && e.ctrlKey && (e.key === 'v' || e.key === 'V')) {
                        e.preventDefault();
                        navigator.clipboard.readText()
                            .then(text => {
                                getPasteDataToElement(element, text);
                            })
                            .catch(err => {
                                console.error('Failed to read clipboard contents: ', err);
                            });

                    }
                }
            });
            // Add event listener for Ctrl+Z to undo
            element.addEventListener('keydown', function(e) {
                if (e.ctrlKey && (e.key === 'z' || e.key === 'Z')) {
                    e.preventDefault();
                    if (currentValueIndex > 0) {
                        currentValueIndex--;
                        element.value = valueHistory[currentValueIndex];
                    }
                }
            });
            element.addEventListener('keydown', function(e) {
                if (e.ctrlKey && (e.key === 'y' || e.key === 'Y')) {
                    e.preventDefault();
                    if (currentValueIndex < valueHistory.length - 1) {
                        currentValueIndex++;
                        element.value = valueHistory[currentValueIndex];
                    }
                }
            });
            element.addEventListener('keydown', function(e) {
                if (e.ctrlKey && (e.key === 'c' || e.key === 'C')) {
                    navigator.clipboard.writeText(element.value.substring(element.selectionStart, element.selectionEnd));
                }
            });
            element.addEventListener('input', function() {
                saveValueToHistory(element);
            });
        });
    }
}
